export const formatDateInput = (value) => {
  let v = value.replace(/\D/g, '').slice(0, 8); // Remove non-digits & limit to 8
  const parts = [];
  if (v.length > 0) parts.push(v.slice(0, 2));
  if (v.length > 2) parts.push(v.slice(2, 4));
  if (v.length > 4) parts.push(v.slice(4));
  return parts.join('/');
};